<template>
  <section class="journal smart-journal text-big" style="">
    <div class="container maxWidth-md">
      <div class="row">
        <div class="col-sm-6 text-left">
          <div style="height: 20px"></div>

          <div class="journal-page" style="position: relative">
            <div style="position: absolute; top: 5px; right: 8px; color: #999">1</div>
            <textarea
              class="journal-textarea journal-textarea-x"
              v-model="title"
              aria-label="title"
            ></textarea>
            <div
              style="height: 2px; background-color: blue; margin-top: -5px; margin-bottom: 20px"
            ></div>
            <div class="journal-paper" style="position: relative">
              <textarea
                v-model="body"
                ref="textareaRef"
                class="journal-textarea journal-main-textarea"
                style="width: 100%"
                aria-label="journal-entry"
              ></textarea>
              <div class="journal-textarea-backing" v-html="bodyHtml"></div>
              <div class="journal-watermark">{{ dynamicWatermark }}</div>
              <div class="journal-suggestion-box visible-xs">
                <br />
                Suggestions:
                <div
                  v-bind:key="i.toString() + 'a'"
                  v-for="(item, i) in itemsInDisplayOrder.slice(0, 1)"
                  class="journal-suggestion"
                >
                  <button
                    v-if="itemsInDisplayOrder[2]"
                    @click="refresh(item, itemsInDisplayOrder[1])"
                    style="float: right"
                    class="btn btn-default"
                    type="button"
                  >
                    <span class="glyphicon glyphicon-refresh"></span>
                  </button>
                  <a href="javascript:void(0)" @click="insert(item, itemsInDisplayOrder[1])"
                    ><span class="journal-body-hash">#</span
                    ><span class="journal-body-heading">{{ item.text }}</span> <br />
                    {{ item.recommendationReason }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div style="display: none">
            {{ editContext }}
          </div>
          <div class="journal-instructions"></div>
        </div>
        <div class="col-sm-6">
          <div class="journal-suggestion-box hidden-xs" style="margin-left: 15px">
            <br />
            Suggestions:
            <br />
            <br />
            <div
              v-bind:key="i.toString() + 'a'"
              v-for="(item, i) in itemsInDisplayOrder.slice(0, 2)"
              class="journal-suggestion"
            >
              <button
                v-if="itemsInDisplayOrder[2]"
                @click="refresh(item, itemsInDisplayOrder[2])"
                style="float: right"
                class="btn btn-default"
                type="button"
              >
                <span class="glyphicon glyphicon-refresh"></span>
              </button>
              <a href="javascript:void(0)" @click="insert(item, itemsInDisplayOrder[2])"
                ><span class="journal-body-hash">#</span
                ><span class="journal-body-heading">{{ item.text }}</span> <br />
                {{ item.recommendationReason }}</a
              >
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
/* eslint-disable no-restricted-syntax */
import { Tooltip } from "uiv";
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { csContext } from "../../services/cs-context";
import processPromptVars, {
  applyVars,
  getDataContext,
  syntaxToApiCall,
} from "../smart-scratchpad/process-prompt-vars";
import chat, { multiChat } from "../smart-scratchpad/chat";
import { splitRegex } from "../smart-search/complete";
import shuffled from "../smart-search/shuffled";
import { CmsSmartJournalPage } from "../../services/cms/cms-type-definitions";
import hotReloadPreserve from "./hot-reload-preserve";
import {
  codes,
  getContinuations,
  getReasoning,
  getReasoning2,
  getWatermark,
  headingsFromSubtitle,
  headingsFromTitle,
  letterToNumber,
  mergeTopic,
  startersFromSubtitle,
  startersFromSubtitleWithAttitude,
} from "./prompts";
import { jyranians } from "./jyranians";

interface IdeaItem {
  text: string;
  recommended: boolean;
  recommendationReason: string;
  strengthIndexes: number[];
  inserted: boolean;
  hides: IdeaItem | null;
  replacedBy: IdeaItem | null;
  replaces: IdeaItem | null;
}

interface IdeaGroup {
  heading: string;
  choice: string | null;
  mergedTopic: string;
  allItems: IdeaItem[];
  curatedItems: IdeaItem[];
  version: number;
  parent: IdeaGroup | null;
  type: "heading" | "starter" | "continuation";
  phrase: string;
}

interface EditContext {
  heading: any;
  mode: string;
  title: string;
  body: string;
  phrase: string;
}

const props = defineProps<{
  doc: CmsSmartJournalPage | null;
}>();

// template refs
const textareaRef = ref<HTMLTextAreaElement | null>(null);

const dynamicWatermark = "Write more...";

const dataContext = ref(getDataContext());

const initialTitle = computed(() => {
  return props.doc?.data.page_title.trim() || "What has gone well for me in the past year?";
});

const title = ref(initialTitle);

const editContext = ref<EditContext>({
  mode: "headings",
  title: "",
  body: "",
  phrase: "",
  heading: "",
});

const initialIdeaGroup = computed<IdeaGroup>(() => {
  const arr = [];
  return {
    parent: null,
    choice: null,
    mergedTopic: title.value,
    phrase: "",
    heading: title.value,
    allItems: [],
    curatedItems: arr,
    version: 0,
    type: "heading",
  };
});

const bio = ref("bio");

const body = ref("\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n");
const group = ref<IdeaGroup>(initialIdeaGroup.value);

const bodyFragments = computed(() => {
  const fragments = body.value.split(/(^#)|(\n#)|(\n)/g).filter((x) => x);
  return fragments.map((f, i) => {
    // Html escape f
    const f2 = f.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    if (f2 === "#" || f2 === "\n#") {
      return { className: "journal-body-hash", text: f2 };
    }
    if ((fragments[i - 1] === "#" || fragments[i - 1] === "\n#") && f2 !== "\n") {
      return { className: "journal-body-heading", text: f2 };
    }
    return { className: "journal-body-span", text: f2 };
  });
});

const bodyHtml = computed(() => {
  return bodyFragments.value.map((f) => `<span class="${f.className}">${f.text}</span>`).join("");
});

function refresh(removedItem: IdeaItem, replacingItem: IdeaItem) {
  if (replacingItem) {
    removedItem.replacedBy = replacingItem;
    replacingItem.replaces = removedItem;
  }
}

function ultimateItem(item: IdeaItem) {
  if (item.replacedBy) {
    return ultimateItem(item.replacedBy);
  }
  return item;
}

const itemsInDisplayOrder = computed(() => {
  const pass0 = group.value.curatedItems;
  const pass1 = [] as IdeaItem[];
  // eslint-disable-next-line no-restricted-syntax
  for (const item of group.value.curatedItems) {
    const replacingItem = ultimateItem(item);
    if (!pass1.includes(replacingItem)) {
      pass1.push(replacingItem);
    }
  }
  return pass1;
});

async function setStatements(
  prompt: string,
  ideaGroup: IdeaGroup,
  type: "heading" | "starter" | "continuation",
) {
  const headingsPrompt = await processPromptVars(prompt, dataContext.value);
  ideaGroup.version += 1;
  const { version } = ideaGroup;
  // TODO: when refactoring this to the composition API I realised this is buggy on live site - throwing errors due to the token_bias keys
  await chat(
    {
      ...headingsPrompt.processed,
      token_bias: {
        "1": -100,
        "01": -100,
        "-": -100,
        "\\": -100,
        "Sure": -100,
        "\n": 5,
        "My": 4,
        " my": 5,
      },
    },
    (headingsResponse) => {
      if (version !== ideaGroup.version) {
        return;
      }

      const split = headingsResponse.split(/\n+/g).filter((s) => s.trim());
      let allItems = split.map((s) =>
        s
          .replace(/\\$/g, "")
          .replace(/^\d+\)?(\.\.\.)?|/g, "")
          .trim(),
      );

      if (false && type === "starter") {
        allItems = allItems.map((l) => l.split(":").slice(1).join(":").trim());
      }

      group.value.allItems = allItems.map((text) => ({
        text,
        recommendationReason: "",
        recommended: false,
        inserted: false,
        strengthIndexes: [],
        hides: null,
        hidden: false,
        replacedBy: null,
        replaces: null,
      }));
    },
  );

  const r = getReasoning(group.value.allItems, title.value, 0);
  const p = await processPromptVars(r, dataContext.value);
  const matchedItems = [] as { strengths: string[]; text: string }[];
  const cb = (text: string) => {
    const split = text.split(/- Strengths:+/g).filter((s) => s.trim());

    // eslint-disable-next-line no-restricted-syntax
    for (const sp of split) {
      const matchingLetters = sp.match(/[^A-Za-z]([A-Z])[^A-Za-z]/g) || [];
      const matchingCodes = sp.match(/([0-9][0-9][0-9])/g) || [];

      // eslint-disable-next-line no-restricted-syntax
      for (const code of matchingCodes) {
        const index = codes.indexOf(code);
        if (index >= 0 && index < group.value.allItems.length) {
          if (!group.value.curatedItems.includes(group.value.allItems[index])) {
            group.value.curatedItems.push(group.value.allItems[index]);
          }

          group.value.allItems[index].recommended = true;
          group.value.allItems[index].strengthIndexes = matchingLetters.map((l) =>
            letterToNumber(l.trim()),
          );
        }
      }
    }
  };

  const text = await chat(
    {
      ...p.processed,
      token_bias: {},
    },
    cb,
  );

  // eslint-disable-next-line no-restricted-syntax
  for (const item of group.value.allItems) {
    if (item.strengthIndexes) {
      // eslint-disable-next-line no-await-in-loop
      const awaited = await processPromptVars(
        getReasoning2(item.strengthIndexes, item.text),
        dataContext.value,
      );
      // eslint-disable-next-line no-await-in-loop
      item.recommendationReason = await chat(awaited.processed);
    }
  }
}

const mode = computed(() => {
  return "headings";
});

function getEditContext() {
  const currentTitle = title.value.trim() || "(no title)";
  // Get each of the paragraphs in the doc as an array.
  const lines = [] as string[];

  const currentBody = lines.join("\n");

  // let head = this.editor.state.selection.$head;

  // let depth = head.depth;
  // let node = this.editor.state.selection.$head.parent;

  const heading = "";
  const phrase = "";
  const started = false;
  const finished = false;

  const currentEditContext = {
    mode: mode.value,
    title: currentTitle,
    body: currentBody,
    phrase,
    heading,
  } as EditContext;
  editContext.value = currentEditContext;
  return currentEditContext;
}

const lastGoEditContext = ref(editContext.value);

async function go(): Promise<void> {
  const ec = getEditContext();

  if (
    lastGoEditContext.value.title === ec.title &&
    lastGoEditContext.value.body === ec.body &&
    lastGoEditContext.value.phrase === ec.phrase &&
    lastGoEditContext.value.heading === ec.heading
  ) {
    return;
  }

  lastGoEditContext.value = ec;
  let type: "heading" | "starter" | "continuation" = "heading";

  if (ec.heading.trim()) {
    type = "starter";
  }

  if (ec.phrase.trim() && ec.heading.trim()) {
    type = "continuation";
  }

  // if (ec.title.trim() === this.initialTitle.trim() && !ec.heading.trim()) {
  //   this.group = this.initialIdeaGroup;
  // } else {
  const arr = [];
  const ideaGroup: IdeaGroup = {
    parent: null,
    choice: null,
    mergedTopic: "",
    heading: ec.heading,
    phrase: ec.phrase,
    allItems: [],
    curatedItems: arr,
    version: 0,
    type,
  };

  group.value = ideaGroup;
  let mergedTopic: string;
  setStatements(headingsFromTitle(ec.title), group.value, type);

  // if (type === "starter") {
  //   setStatements(startersFromSubtitle(ec.heading, ec.title), group.value, type);
  // } else if (type === "heading") {
  //   setStatements(headingsFromTitle(ec.title), group.value, type);
  // } else if (type === "continuation") {
  //   setStatements(getContinuations(ec.phrase, ec.heading, ec.title), group.value, type);
  // }
}

function setAttitude(jyranian: string) {
  go();
}

function editCurrentNode(text: string) {
  let from: number;
  let to: number;

  // Get the editor's current node.
}

function deepen(subtopic: string) {
  const parent = group.value;
  const ideaGroup: IdeaGroup = {
    parent,
    heading: subtopic,
    mergedTopic: "",
    choice: subtopic,
    allItems: [],
    curatedItems: [],
    version: 0,
    type: "heading",
    phrase: "",
  };
  group.value = ideaGroup;

  editCurrentNode(subtopic);
  // insertAfterCurrentParagraph(choice, "heading");
  setStatements(headingsFromSubtitle(subtopic, title.value), group.value, "heading");
}

async function getMergedTopic(pageTitle: string, rootTopic: string, subtopic: string) {
  return (await chat(mergeTopic(pageTitle, rootTopic, subtopic))).replace(/"$/g, "");
}

function resize() {
  const textarea = textareaRef.value as HTMLTextAreaElement;
  setTimeout(() => {
    textarea.scroll(0, 0);
    const heightBefore = textarea.scrollHeight;
    textarea.style.height = `${Math.max(heightBefore - 27, 0)}px`;
    textarea.style.height = `${textarea.scrollHeight}px`;
    const heightAfter = textarea.scrollHeight;
    if (heightBefore !== heightAfter) {
      setTimeout(() => resize(), 5);
    }
  }, 0);
}

watch(body, () => {
  resize();
});

function insert(item: IdeaItem, replacingItem: IdeaItem) {
  let insertion = `#${item.text}\n${item.recommendationReason}`;
  if (body.value.trim()) {
    insertion = `\n\n${insertion}`;
  }
  body.value = body.value.trimEnd() + insertion;
  item.inserted = true;
  refresh(item, replacingItem);
}

onMounted(() => {
  hotReloadPreserve({ title: title.value, group: group.value, body: body.value }, "smart-journal", [
    "title",
    "group",
    "body",
  ]);

  // When the selection changes, run a method.
  // this.editor.on("selectionUpdate", () => {
  //   this.go();
  // });

  go();
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/site";

.journal-page {
  margin-left: -10px;
  margin-right: -10px;
}

.journal-body-heading {
  color: #222;
  text-shadow: 0px -0.25px #222, 0.5px 0.5px #aaa;
}

.journal-body-hash {
  color: @innovator-color;
}

.journal-watermark {
  color: #888;
  padding-left: 15px;
}

.journal-textarea {
  width: 100%;
  border: none;
  overflow: hidden;
  outline: none;
  width: 100%;
  background: none;
  line-height: 27px;
  margin: 0;
  margin-bottom: -9px;
  padding: -0px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none; /*remove the resize handle on the bottom right*/
  position: relative;
  z-index: 10;
  padding-left: 15px;
  padding-top: 2px;
  padding-right: 5px;
  caret-color: #444;
}

.journal-main-textarea {
  color: transparent;
}

.journal-textarea-backing {
  white-space: pre-wrap;
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  overflow: hidden;
  outline: none;
  width: 100%;
  background: none;
  line-height: 27px;
  margin: 0;
  padding-top: 2px;
  padding-left: 15px;
  padding-right: 5px;
  min-height: 90px;
  color: #444;
  background: none;
  border: none;
  font-size: 18px;
}

.journal-textarea-backing,
.journal-main-textarea,
.journal-body-hash {
  font-family: "Ampersand", "Libre Franklin", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

@font-face {
  font-family: "Ampersand";
  src: local("Verdana");
  unicode-range: U+0023;
}

.journal-paper {
  line-height: 27px;

  p {
    margin-bottom: 0;
  }
}
.journal-editor-outer h1 {
  line-height: 27px;
  font-size: 18px;
}

.journal-editor-outer h1,
.journal-heading {
  margin: 0;
  color: #444;
  font-size: 18px;
}

.journal-starter {
  color: #444;
}

.journal-editor-outer h2 {
  line-height: 27px;
  font-size: 18px;
  font-weight: normal;
  margin: 0;
}

.journal-suggestion {
  position: relative;
  top: 0;
  right: 0;

  a {
    z-index: 2;
    position: relative;
  }
}

.journal-recommended-suggestion-image {
  width: 60px;
  height: 60px;
  position: absolute;
  right: -45px;
  top: -20px;
  z-index: 1;
}

.journal-editor-outer h1::before,
.journal-heading::before {
  content: " ";
  width: 15px;
  height: 15px;
  position: relative;
  top: 1px;
  left: 0;
  display: inline-block;
  background-image: url(./hash2.png);
  background-size: cover;
  opacity: 0.3;
  margin-right: 3px;
}

.journal-suggestion-box {
  margin-left: 0px;
  margin-right: 5px;
}

.journal-continuation {
  color: #444;
}

.journal-continuation::before,
.journal-starter::after,
.journal-suggestion-phrase::after {
  color: #ccc;
  content: "... ";
}

.journal-editor-outer h1::before {
  content: " ";
  width: 15px;
  height: 15px;
  position: relative;
  top: 5px;
  left: 0;
  display: inline-block;
  background-image: url(./hash2.png);
  background-size: cover;
  opacity: 0.3;
  margin-right: 3px;
}

.journal-editor-outer h2::before {
  content: " ";
  padding-left: 20px;
}

.journal-editor-outer > div {
  outline: none;
  border: none;
}

.pseudo-caret {
  position: relative;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
}
.pseudo-caret::after {
  content: "";
  display: inline-block;
  position: absolute;
  height: 22px;
  left: -2px;
  top: 0px;
  width: 4px;
  // Animated rainbow background
  background: linear-gradient(
    to bottom,
    @servant-color 0%,
    @executional-color 14%,
    @entrepreneurial-color 28%,
    @charismatic-color 42%,
    @professional-color 56%,
    @strategist-color 70%,
    @transformational-color 84%,
    @servant-color 100%
  );
  background-size: 200% 200%;
  animation: rainbow 2s linear infinite;
  z-index: 1;
  border: 0.2px solid black;
  border-radius: 2px;
}

.pseudo-caret {
  position: relative;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
}
.pseudo-caret::after {
  content: "";
  display: inline-block;
  position: absolute;
  height: 22px;
  left: -2px;
  top: 0px;
  width: 4px;
  // Animated rainbow background
  background: linear-gradient(
    to bottom,
    @servant-color 0%,
    @executional-color 14%,
    @entrepreneurial-color 28%,
    @charismatic-color 42%,
    @professional-color 56%,
    @strategist-color 70%,
    @transformational-color 84%,
    @servant-color 100%
  );
  background-size: 200% 200%;
  animation: rainbow 2s linear infinite;
  z-index: 1;
  border: 0.2px solid black;
  border-radius: 2px;
}

@keyframes rainbow {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 200%;
  }
}

pre.jtb {
  white-space: pre-wrap;
  position: absolute;
  border: none;
  overflow: hidden;
  outline: none;
  width: 100%;
  background: none;
  line-height: 27px;
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 90px;
  word-break: inherit;
  word-wrap: inherit;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
  font-family: inherit;

  color: transparent;
}
.journal-suggestion.journal-suggestion {
  //border-bottom: 5px solid @charismatic-color;
  line-height: 27px;
  margin-left: 0;
  a {
    color: #444;
  }

  &,
  &:hover,
  &:focus,
  &:active {
    color: inherit;
    text-decoration: none;
  }
}
.journal-suggestion-tooltip span {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: @charismatic-color;
  text-decoration-thickness: 1.5px;
  text-underline-offset: 4px;
}
span.journal-body-hash:nth-of-type(9n + 1) {
  color: @innovator-color;
}
span.journal-body-hash:nth-of-type(9n + 2) {
  color: @practical-color;
}
span.journal-body-hash:nth-of-type(9n + 3) {
  color: @charismatic-color;
}
span.journal-body-hash:nth-of-type(9n + 4) {
  color: @servant-color;
}
span.journal-body-hash:nth-of-type(9n + 5) {
  color: @executional-color;
}
span.journal-body-hash:nth-of-type(9n + 6) {
  color: @strategist-color;
}
span.journal-body-hash:nth-of-type(9n + 7) {
  color: @professional-color;
}
span.journal-body-hash:nth-of-type(9n + 8) {
  color: @entrepreneurial-color;
}
span.journal-body-hash:nth-of-type(9n + 9) {
  color: @transformational-color;
}
.journal-page {
  border-radius: 5px;
  box-shadow: 0px 0px 4px;
}
.journal-textarea-wrapper {
  margin-top: -7px;
}
.journal-textarea-wrapper-0 {
  margin-top: 2px;
  border-left: 3px solid @innovator-color;
  .journal-bubble {
    color: @innovator-color;
  }
}
.journal-textarea-wrapper-1 {
  border-left: 3px solid @charismatic-color;
  .journal-bubble {
    color: @charismatic-color;
  }
}
.journal-textarea-wrapper-2 {
  border-left: 3px solid @executional-color;
  .journal-bubble {
    color: @executional-color;
  }
}
.journal-textarea-wrapper-3 {
  border-left: 3px solid purple;
  .journal-bubble {
    color: purple;
  }
}
.journal-textarea-wrapper-4 {
  border-left: 3px solid orange;
  .journal-bubble {
    color: orange;
  }
}
.journal-textarea-wrapper-5 {
  border-left: 3px solid grey;
}
.journal-textarea-wrapper-6 {
  border-left: 3px solid turquoise;
}
.journal-textarea-wrapper-7 {
  border-left: 3px solid indianred;
}
.journal-textarea-wrapper-8 {
  border-left: 3px solid yellow;
}
.journal-textarea-wrapper-9 {
  border-left: 3px solid black;
}
.journal-paper {
  border-radius: 5px;
  min-height: 500px;
  background: repeating-linear-gradient(
    white,
    white 25px,
    lighten(#9198e5, 20%) 26px,
    lighten(#9198e5, 20%) 27px
  );
}
.journal-instructions {
  color: #777;
}
.journal-textarea-x {
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 0px;
  line-height: 1.1;
  text-align: center;
}
</style>
